<template>
  <div class="search-list">
    <CommonHeader class="common-header" :pinned="true">{{ $t('expert.found') }}</CommonHeader>

    <div class="topic-nav">
      <RouterLink
        v-for="(topic,index) in topics"
        :key="topic.id"
        :to="{ name: 'search', query: { topic: topic.id } }"
        class="item"
        exact
        replace
        tag="div"
        active-class="active"
      >
        <span class="m-text-cut">{{ topic.name }}</span>
      </RouterLink>
    </div>
    <main>
      <JoLoadMore
        ref="loadmore"
        class="loadmore"
        :auto-load="false"
        @onRefresh="onRefresh"
        @onLoadMore="onLoadMore"
      >
        <div
          v-for="(item, index) in list"
          :key="item.id"
          class="group-item-wrap"
        >
          <RankListItem
            :key="item.id"
            :user="item"
            :index="index"
          >
            <p class="bio-depart m-text-cut">{{ item.office }}{{ item.department ? `-${item.department}` : '' }}</p>
            <p v-if="item.title" class="bio-depart m-text-cut">{{ item.title }}</p>
            <div class="tags">
              <div
                v-for="(tag, ind) in item.tags_show.slice(0, 3)"
                :key="tag.name+ind"
              >
                <span class="tag-name">{{ tag.name }}</span>
                <span
                  v-if="ind < 2 && ind < item.tags_show.length - 1"
                  class="dot"
                >·</span>
              </div>
            </div>
          </RankListItem>
        </div>
      </JoLoadMore>
    </main>
  </div>
</template>

<script>
  import RankListItem from '../rank/components/RankUsersComponent2.vue'
  import { query as queryTopics, findExperts } from '@/api/question/topics'
  export default {
    components: {
      RankListItem,
    },
    data: () => ({
      list: [],
      topics: [],
    }),
    computed: {
      topic () {
        return this.$route.query.topic || 'hot'
      },
    },
    watch: {
      topic (val) {
        val && this.$refs.loadmore.beforeRefresh()
      },
    },
    mounted () {
      this.queryTopics()
      this.$refs.loadmore.beforeRefresh()
    },
    methods: {
      onRefresh () {
        const params = { limit: 15 }
        if (this.topic === 'hot') {
          findExperts(0, params).then(res => {
            this.list = res.data
            this.$refs.loadmore.afterRefresh(res.data.length < params.limit)
          })
        } else {
          findExperts(this.topic, params).then(res => {
            this.list = res.data
            this.$refs.loadmore.afterRefresh(res.data.length < params.limit)
          })
        }
      },
      onLoadMore (callback) {
        const params = { limit: 15, offset: this.list.length }
        if (this.topic === 'hot') {
          findExperts(0, params).then(res => {
            this.list = [...this.list, ...res.data]
            this.$refs.loadmore.afterLoadMore(res.data.length < params.limit)
          })
        } else {
          findExperts(this.topic, params).then(res => {
            this.list = [...this.list, ...res.data]
            this.$refs.loadmore.afterLoadMore(res.data.length < params.limit)
          })
        }
      },
      queryTopics () {
        queryTopics({ limit: 100 }).then(({ data }) => {
          this.topics = [{ name: '热门专家', id: 'hot' }, ...data]
        })
      },
    },
  }
</script>

<style lang="less" scoped>
.common-header {

    background-color: #1a1a1a;
    color: #fff;
}
.loadmore {
  padding-top: 90+90px;
  height: 100%;
}
.topic-nav {
  position: fixed;
  display: flex;
  align-items: center;
  padding: 0 30px;
  top: 90px;
  height: 90px;
  left: 0;
  right: 0;
  flex-wrap: nowrap;
  font-size: 26px;
  color: @text-color3;
  overflow-y: auto;
  border-bottom: 1px solid @border-color; /* no */
  z-index: 10;
  max-width: 1080px;
  background-color: #fff;

  .item {
    flex: 0 0 auto;
    transition: all 0.1s ease;

    + .item {
      margin-left: 50px;
    }

    &.active {
      color: @text-color1;
      font-size: 30px;
      border-bottom: 4px solid @tool-bar-bg;
    }
  }
}
.tags {
  > div {
    font-size: 24px;
    display: inline-flex;
    color: #3283a2;

  }
  .dot {
    color: @text-color3;
    display: inline-block;
    margin:0 10px;
  }
  .tag-name {
      display: inline-block;
      white-space: nowrap;
      max-width: 180px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      text-align: center;

  }
}
.bio-depart {
  margin-top: 5px;
  white-space: wrap !important;
}
</style>
